import { useEffect } from 'react';

import { useAgencyConfiguration } from '../agency/AgencyConfigurationContext';

export type NgPageHeaderProps = {
  title?: string;
  separator?: string;
};

const DEFAULT_APP_NAME = 'NG-SO Portal';

export function NgPageHeader({ title, separator = ' - ' }: NgPageHeaderProps) {
  const configuration = useAgencyConfiguration();
  const appTitle = configuration?.agencyPortalConfiguration.appName ?? DEFAULT_APP_NAME;
  const effectivePageTitle = title == null ? appTitle : `${title}${separator}${appTitle}`;

  useEffect(() => {
    document.title = effectivePageTitle;
  }, [effectivePageTitle]);

  return null;
}
